import { useMemo } from 'react';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import useAccountConfig from 'modules/taboola-common-frontend-modules/account-configurations/hooks/useAccountConfig';

export const useMetaModelExcludeNodeList = () => {
    const { [FEATURE_FLAGS.DYNAMIC_REPORTS_METAMODEL_EXCLUDE_NODE_LIST]: excludeNodes } = useAccountConfig([
        FEATURE_FLAGS.DYNAMIC_REPORTS_METAMODEL_EXCLUDE_NODE_LIST,
    ]);

    const excludeNodeList = useMemo(() => {
        return excludeNodes.trim().split(',');
    }, [excludeNodes]);

    return excludeNodeList;
};
